import { Splide } from '@splidejs/react-splide'
import map from 'lodash/map'
import React, { createRef, FC, RefObject } from 'react'
import styled, { css } from 'styled-components'

import { Button } from '@Components/Button'
import { UVPRINT_EXAMPLE_ASSETS } from '@Components/Personalization/Modals/UVPrint/UVPrintAssets'
import { UVPrintInfo } from '@Components/Personalization/Modals/UVPrint/UVPrintInfo'
import {
  PersonalizationCaption,
  PersonalizationInformation,
  PersonalizationItemRoot,
  PersonalizationSubTitle,
  PersonalizationTitle,
} from '@Components/Personalization/Styles/Personalization.styled'
import { HorizontalSlider } from '@Components/Slider/HorizontalSlider'
import { up } from '@Globals/Style/breakpoints'
import { useTranslation } from '@Globals/Translations'

interface Props {
  inputRef: RefObject<HTMLInputElement>
  price: string
}

const StyledItemRoot = styled(PersonalizationItemRoot)(({ theme }) => css`
  padding-top: 16px;
  padding-bottom: 0;
  margin-bottom: 0;
  border-radius: ${theme.borderRadius};
  overflow: hidden;

  &:last-of-type {
    margin-bottom: 0;
  }

  ${up('tablet')} {
    padding-top: 0;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: flex-start;
  }
`)

const StyledHorizontalSlider = styled(HorizontalSlider)`
  margin-top: 10px;

  .splide > .splide__pagination {
    bottom: 0;
  }

  img {
    max-height: 280px;
  }

  ${up('tablet')} {
    margin-top: 40px;
  }
`

const UVPrintTopContainer = styled.div(({ theme }) => css`
  display: flex;
  flex-direction: column;

  ${up('tablet')} {
    background: ${theme.colors.greyLightest};
    padding-top: 40px;
    padding-bottom: 40px;
    height: 550px;
    width: 50%;
  }
`)

const UVPrintBottomContainer = styled(PersonalizationInformation)`
  background: white;

  ${up('tablet')} {
    padding-top: 24px;
    width: 50%;
    max-width: unset;
    height: 550px;
  }
`

const UVPrintSubtitle = styled(PersonalizationSubTitle)`
  padding-top: 0;
  font-size: 15px;

  ${up('phablet')} {
    font-size: 18px;
  }

  ${up('tablet')} {
    padding-top: 16px;
  }
`

const UVPrintStepOne: FC<Props> = ({ inputRef, price }) => {
  const { t } = useTranslation('products')
  const sliderRef = createRef<Splide>()
  const captions = map(UVPRINT_EXAMPLE_ASSETS, 'caption')

  return (
    <StyledItemRoot>
      <UVPrintTopContainer>
        <PersonalizationTitle>{t('UV_PRINT_TITLE_STEP_1')}</PersonalizationTitle>
        <StyledHorizontalSlider
          assets={UVPRINT_EXAMPLE_ASSETS}
          captions={captions}
          disableFullscreen
          overlayActive={false}
          ref={sliderRef}
        />
      </UVPrintTopContainer>
      <UVPrintBottomContainer>
        <UVPrintSubtitle>{t('UV_PRINT_PERSONALIZED_TITLE')}</UVPrintSubtitle>
        <PersonalizationCaption center>
          {t('UV_PRINT_PERSONALISED_DESCRIPTION')}
        </PersonalizationCaption>
        <Button onClick={() => inputRef?.current?.click()}>
          {t('UV_PRINT_UPLOAD_PICTURE')}
        </Button>
        <UVPrintInfo price={price} step={1} />
      </UVPrintBottomContainer>
    </StyledItemRoot>
  )
}

export default UVPrintStepOne

